import { render, staticRenderFns } from "./CardAdminCandidatos.vue?vue&type=template&id=672df9f3&scoped=true"
import script from "./CardAdminCandidatos.vue?vue&type=script&lang=js"
export * from "./CardAdminCandidatos.vue?vue&type=script&lang=js"
import style0 from "./CardAdminCandidatos.vue?vue&type=style&index=0&id=672df9f3&prod&scoped=true&lang=css"
import style1 from "../../assets/styles/personal-admin.css?vue&type=style&index=1&id=672df9f3&prod&scoped=true&lang=css&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "672df9f3",
  null
  
)

export default component.exports